import values from 'lodash/values'
import { createSelector } from 'reselect'

const _detailUserError = state => state.userDetail.error
const _detailUserPending = state => state.userDetail.pending
const _groups = state => state.groups.data
const _groupsError = state => state.groups.error
const _groupsPending = state => state.groups.pending

export const detailUser = state => state.userDetail.detailUser
export const groupsDone = state => state.groups.done
export const userGetDone = state => state.userDetail.userGetDone
export const userGetError = state => state.userDetail.userGetError
export const userGetPending = state => state.userDetail.userGetPending

const groups = createSelector(
  [_groups],
  grps => {
    return values(grps).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  },
)

export const groupsOptions = createSelector(
  [groups],
  groups => {
    return groups.map(group => ({ text: group.name, value: group.id }))
  },
)

export const error = createSelector(
  [_groupsError, _detailUserError],
  (groupsError, detailUserError) => {
    return groupsError || detailUserError
  },
)

export const pending = createSelector(
  [_groupsPending, _detailUserPending],
  (groupsPending, detailUserPending) => {
    return groupsPending || detailUserPending
  },
)
